<template lang="pug">
div
  v-row(no-gutters)
    v-col(cols="12" sm="5")
      div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('provider_detail') }}
      div.text-sm.neutral500--text {{ $t('provider_detail_desc') }}

      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('profile_image') }}
      div.d-flex.align-center.mt-2  
        v-avatar(size="64" color="neutral300")
          div(v-if="resizeImageFileUrl" align="center")
            v-img(:src="resizeImageFileUrl" contain max-height="64" max-width="64")
              template(v-slot:placeholder)
                v-row(class="fill-height ma-0" align="center" justify="center")
                  v-progress-circular(indeterminate color="grey")
          v-icon(v-else color="neutral500" size="30") $yzi-user-03

        div.file-change-layout.ml-4
          v-btn.button-sm(color="basic700" outlined depressed) {{ $t('update') }}
          input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 92px !important")

      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('provider_name') }}
      v-text-field.text-md.font-normal.mt-2.round-xl(v-model="name" :placeholder="$t('provider_name_placeholder')" outlined :rules="rules.not_empty" dense height="48" hide-details="auto")

      div.text-md.font-medium.neutral700--text.mt-8 {{ $t('type_of_provider') }}
      provider-type-dropdown.mt-2(v-model="type" field-class="text-md" :error="errorProviderType" @change="removeError")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'
import ProviderTypeDropdown from '@/components/clinic/appointment/custom/ProviderTypeDropdown.vue'

export default {
  name: 'ProviderDetails',
  props: ['errorType'],
  components: { ProviderTypeDropdown },
  data () {
    return {
      isLoading: false,
      name: null,
      type: null,
      resizeImageFileUrl: '',
      resizeImageFile: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      provider: 'clinic/getProvider',
    }),
    detailsData () {
      return {
        name: this.name,
        type: this.type,
        profile_image: this.resizeImageFile
      }
    },
    errorProviderType: {
      get () {
        return this.errorType
      },
      set (val) {
        this.$emit('update:errorType', val)
      }
    }
  },
  watch: {
    detailsData: {
      deep: true,
      handler (val) {
        this.$store.commit('clinic/updateTempProvider', val)
      } 
    }
  },
  mounted () {
    if (this.provider) {
      this.setData(this.provider)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    setData (provider) {
      if (provider.profile_image) {
        this.resizeImageFileUrl = provider.profile_image.file
      }
      this.name = provider.name
      this.type = provider.type
    },
    removeError () {
      if (this.type) {
        this.errorProviderType = false
      }
    },
  }
}
</script>

<style scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>